import {
  CreateServiceRequestType,
  UpdateServiceRequestType,
} from 'src/app/shared/types/requests.types';

export namespace RequestsAction {
  export class GetRequests {
    static readonly type = '[RequestsAction] GetRequests';
    constructor() {}
  }

  export class GetRequestDetail {
    static readonly type = '[RequestsAction] GetRequestDetail';
    constructor(public id: number) {}
  }

  export class GetCreateInfo {
    static readonly type = '[RequestsAction] GetCreateInfo';
    constructor() {}
  }

  export class CreateServiceRequest {
    static readonly type = '[RequestsAction] CreateServiceRequest';
    constructor(public body: CreateServiceRequestType) {}
  }

  export class GetUpdateInfo {
    static readonly type = '[RequestsAction] GetUpdateInfo';
    constructor(public id: number) {}
  }

  export class UpdateServiceRequest {
    static readonly type = '[RequestsAction] UpdateServiceRequest';
    constructor(public body: UpdateServiceRequestType) {}
  }
  
  export class DeleteRequest {
    static readonly type = '[RequestsAction] DeleteRequest';
    constructor(public id: number) {}
  }
}
